/* import __COLOCATED_TEMPLATE__ from './connected-modal.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { GlobalAddress } from '@square/dashboard-protos/models/squareup/common/location';
import { SIGNATURE_FONT_MEMBERS } from '@banking/ui/models/common/card-customization';
import { emit, select } from '@banking/ui/services/card-management/cancel-card-modal';
import assert from '@banking/ui/utils/assert';
import { getImageUriFromCardCustomization } from '@banking/ui/utils/card/image-bytes-utils';
import { AuthorizedUserCardScreen, Screen, userClickNextAction, userClickBackAction, userClickCloseModalAction, userClickConfirmCancellationAction, ChosenAddress, CancellationType, SUCCESS_SCREENS } from '@banking/ui/workflows/card-settings/cancel-card';
import { AccountHolderCardScreen, chosenAddressChangeAction, createCardAction, phoneNumberChangeAction, shippingAddressChangeAction, userChooseAccountClosureFlowAction, userChooseDeactivateOwnCardsFlowAction, userClickCancellationReasonAction, userClickConfirmCardCustomizationAction, userClickDeactivateAccountAction, userClickDeactivateOwnCardsAction, userClickDesignNewCardAction, userClickEditShippingAddressAction, userClickOrderReplacementUsingSameDesignAction, userClickSaveShippingAddressAction, userClickSendFeedbackAction, userClickSendIdvVerificationLinkAction, userClickStartChallengeAction } from '@banking/ui/workflows/card-settings/cancel-card/account-holder-card';
import { signatureTextChangeAction, signatureFontChangeAction, newCustomizationActiveChangeAction } from '@banking/ui/workflows/common/card-customization';
import { addressEntry } from '@banking/ui/utils/address';
import { getCardholder } from '@banking/ui/utils/card/card';
export let NavButtonAction = /*#__PURE__*/function (NavButtonAction) {
  NavButtonAction[NavButtonAction["Close"] = 0] = "Close";
  NavButtonAction[NavButtonAction["GoBack"] = 1] = "GoBack";
  return NavButtonAction;
}({});

// Most of the time, we display the close button on the first and last screens
// and the back button on other screens. The ones below are special cases.
const FLOW_NAV_ACTION = {
  [AccountHolderCardScreen.DocumentBasedIdvResendLink]: NavButtonAction.GoBack,
  [AccountHolderCardScreen.OtherProblemWithCard]: NavButtonAction.GoBack,
  [AccountHolderCardScreen.SendFeedback]: NavButtonAction.Close
};
const getNavButtonAction = state => {
  const {
    flow,
    current
  } = state.navigation;
  const isFirstOrLastScreen = current === flow[0] || current === flow.at(-1);
  if (FLOW_NAV_ACTION[current] === NavButtonAction.GoBack || !isFirstOrLastScreen && FLOW_NAV_ACTION[current] !== NavButtonAction.Close) {
    return NavButtonAction.GoBack;
  } else {
    return NavButtonAction.Close;
  }
};
const getCardSummary = card => {
  return {
    // TODO(tugce): Update once backend proto includes all card brands
    brand: 'Mastercard',
    cardholder: getCardholder(card),
    isAccountHolderCard: card.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER),
    lastFour: card.lastFour
  };
};
let ConnectedPage = (_dec = select(state => state.businessName), _dec2 = select(state => state.cardHolder), _dec3 = select(state => state.navigation.current), _dec4 = select(state => {
  return SUCCESS_SCREENS.includes(state.navigation.current);
}), _dec5 = select(state => state.modalOpen), _dec6 = select(state => state.cardBrand), _dec7 = select(state => state.lastFour), _dec8 = select(state => {
  const {
    businessName,
    cardCustomization,
    cardHolder
  } = state;
  const customizationImageDataURL = cardCustomization ? getImageUriFromCardCustomization(cardCustomization) : '';
  return {
    businessName,
    cardholder: cardHolder,
    customizationImageDataURL,
    // These are only needed for viewing card details at the back, which are not used yet in this flow.
    cvc: '',
    expirationDate: '',
    fullPan: ''
  };
}), _dec9 = select(state => {
  const {
    cardBrand,
    lastFour,
    cardHolder,
    cancellationType
  } = state;
  return {
    brand: cardBrand,
    cardholder: cardHolder,
    isAccountHolderCard: cancellationType === CancellationType.AccountHolderCard,
    lastFour
  };
}), _dec10 = select(state => {
  const {
    cards
  } = state;
  return cards.map(getCardSummary);
}), _dec11 = select(state => {
  const {
    accountOwnerCards
  } = state;
  return accountOwnerCards.map(getCardSummary);
}), _dec12 = select(state => state.countryAddressData), _dec13 = select(state => state.chosenAddress), _dec14 = select(state => {
  const {
    chosenAddress,
    normalizedAddress,
    updatedShippingAddress
  } = state;
  return chosenAddress === ChosenAddress.Normalized && normalizedAddress ? normalizedAddress : updatedShippingAddress;
}), _dec15 = select(state => state.loading), _dec16 = select(getNavButtonAction), _dec17 = select(state => state.phoneNumber), _dec18 = select(state => {
  const {
    phoneNumber
  } = state;
  return `***-***-${phoneNumber.slice(-4)}`;
}), _dec19 = select(state => state.phoneNumberError), _dec20 = select(state => state.newCustomizationActive), _dec21 = select(state => {
  const {
    normalizedAddress
  } = state;
  return addressEntry(normalizedAddress || GlobalAddress.create());
}), _dec22 = select(state => state.signatureFont), _dec23 = select(state => state.signatureText), _dec24 = select(state => state.shippingAddress), _dec25 = select(state => state.updatedShippingAddress), _dec26 = select(state => {
  const {
    updatedShippingAddress
  } = state;
  return addressEntry(updatedShippingAddress);
}), (_class = class ConnectedPage extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "AccountHolderCardScreen", AccountHolderCardScreen);
    _defineProperty(this, "AuthorizedUserCardScreen", AuthorizedUserCardScreen);
    _defineProperty(this, "NavButtonAction", NavButtonAction);
    _defineProperty(this, "Screen", Screen);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor, this);
    _initializerDefineProperty(this, "businessName", _descriptor2, this);
    _initializerDefineProperty(this, "cardHolder", _descriptor3, this);
    _initializerDefineProperty(this, "currentScreen", _descriptor4, this);
    _initializerDefineProperty(this, "hideHeader", _descriptor5, this);
    _initializerDefineProperty(this, "modalOpen", _descriptor6, this);
    _initializerDefineProperty(this, "brand", _descriptor7, this);
    _initializerDefineProperty(this, "panSuffix", _descriptor8, this);
    _initializerDefineProperty(this, "cardPreview", _descriptor9, this);
    _initializerDefineProperty(this, "cardSummary", _descriptor10, this);
    _initializerDefineProperty(this, "cardSummaryList", _descriptor11, this);
    _initializerDefineProperty(this, "ownCardsSummaryList", _descriptor12, this);
    _initializerDefineProperty(this, "countryAddressData", _descriptor13, this);
    _initializerDefineProperty(this, "chosenAddress", _descriptor14, this);
    _initializerDefineProperty(this, "chosenShippingAddress", _descriptor15, this);
    _initializerDefineProperty(this, "loading", _descriptor16, this);
    _initializerDefineProperty(this, "navButtonAction", _descriptor17, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor18, this);
    _initializerDefineProperty(this, "displayPhoneNumber", _descriptor19, this);
    _initializerDefineProperty(this, "phoneNumberError", _descriptor20, this);
    _initializerDefineProperty(this, "newCustomizationActive", _descriptor21, this);
    _initializerDefineProperty(this, "normalizedAddressEntry", _descriptor22, this);
    _initializerDefineProperty(this, "signatureFont", _descriptor23, this);
    _initializerDefineProperty(this, "signatureText", _descriptor24, this);
    _initializerDefineProperty(this, "shippingAddress", _descriptor25, this);
    _initializerDefineProperty(this, "updatedShippingAddress", _descriptor26, this);
    _initializerDefineProperty(this, "userInputAddressEntry", _descriptor27, this);
  }
  onCancelResendLink() {
    return userClickBackAction();
  }
  onChooseDeactivateOwnCardsClick() {
    return userChooseDeactivateOwnCardsFlowAction();
  }
  onChosenAddressChange(chosenAddress) {
    return chosenAddressChangeAction(chosenAddress);
  }
  onConfirmAddressSelectionClick() {
    return userClickNextAction();
  }
  onConfirmCardCustomizationClick() {
    return userClickConfirmCardCustomizationAction();
  }
  onConfirmCloseClick() {
    return userClickDeactivateAccountAction();
  }
  onConfirmPhoneNumberClick() {
    return userClickSendIdvVerificationLinkAction();
  }
  onConfirmResendClick() {
    return userClickStartChallengeAction();
  }
  onConfirmUnverifiedAddressClick() {
    return userClickNextAction();
  }
  onConfirmationClick() {
    return userClickConfirmCancellationAction();
  }
  onConfirmShippingAddressClick() {
    return userClickNextAction();
  }
  onContinueClosingAccountClick() {
    return userChooseAccountClosureFlowAction();
  }
  onDeactivateOwnCardsClick() {
    return userClickDeactivateOwnCardsAction();
  }
  onEditUnverifiedAddressClick() {
    return userClickBackAction();
  }
  onReplacementConfirmButtonClick() {
    return userClickConfirmCancellationAction(true);
  }
  onDesignNewCardClick() {
    return userClickDesignNewCardAction();
  }
  onEditShippingAddressClick() {
    return userClickEditShippingAddressAction();
  }
  onMarketDialogDismissed() {
    return userClickCloseModalAction();
  }
  onNavClick() {
    switch (this.navButtonAction) {
      case NavButtonAction.Close:
        return userClickCloseModalAction();
      case NavButtonAction.GoBack:
        return userClickBackAction();
    }
  }
  onNewCustomizationActive(active) {
    assert(typeof active === 'boolean');
    return newCustomizationActiveChangeAction(active);
  }
  onDocumentBasedIdvConfirmConsentClick() {
    return userClickNextAction();
  }
  onOrderCardClick() {
    return createCardAction();
  }
  onOrderReplacementUsingSameDesignClick() {
    return userClickOrderReplacementUsingSameDesignAction();
  }
  onPhoneNumberChange(phoneNumber) {
    return phoneNumberChangeAction(phoneNumber);
  }
  onResendDocumentBasedIdvLinkClick() {
    return userClickStartChallengeAction();
  }
  onSaveShippingAddressClick() {
    return userClickSaveShippingAddressAction();
  }
  onSelectCancellationReason(reason) {
    return userClickCancellationReasonAction(reason);
  }
  onShippingAddressUpdate(address) {
    return shippingAddressChangeAction(address);
  }
  onSignatureTextChange(signatureText) {
    assert(typeof signatureText === 'string');
    return signatureTextChangeAction(signatureText);
  }
  onSignatureFontChange(signatureFont) {
    assert(SIGNATURE_FONT_MEMBERS.includes(signatureFont));
    return signatureFontChangeAction(signatureFont);
  }
  onSkipFeedbackClick() {
    return userClickNextAction();
  }
  onSendFeedbackClick(feedback) {
    assert(typeof feedback === 'string');
    return userClickSendFeedbackAction(feedback);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "businessName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cardHolder", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "currentScreen", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hideHeader", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "modalOpen", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "brand", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "panSuffix", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "cardPreview", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "cardSummary", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "cardSummaryList", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "ownCardsSummaryList", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "countryAddressData", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "chosenAddress", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "chosenShippingAddress", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "loading", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "navButtonAction", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "displayPhoneNumber", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberError", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "newCustomizationActive", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "normalizedAddressEntry", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "signatureFont", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "signatureText", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "shippingAddress", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "updatedShippingAddress", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "userInputAddressEntry", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onCancelResendLink", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onCancelResendLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChooseDeactivateOwnCardsClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onChooseDeactivateOwnCardsClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChosenAddressChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onChosenAddressChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmAddressSelectionClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmAddressSelectionClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmCardCustomizationClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmCardCustomizationClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmCloseClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmCloseClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmPhoneNumberClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmPhoneNumberClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmResendClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmResendClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmUnverifiedAddressClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmUnverifiedAddressClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmationClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmationClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onConfirmShippingAddressClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onConfirmShippingAddressClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onContinueClosingAccountClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onContinueClosingAccountClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDeactivateOwnCardsClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onDeactivateOwnCardsClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEditUnverifiedAddressClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onEditUnverifiedAddressClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onReplacementConfirmButtonClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onReplacementConfirmButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDesignNewCardClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onDesignNewCardClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEditShippingAddressClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onEditShippingAddressClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMarketDialogDismissed", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onMarketDialogDismissed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNavClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onNavClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNewCustomizationActive", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onNewCustomizationActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDocumentBasedIdvConfirmConsentClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onDocumentBasedIdvConfirmConsentClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onOrderCardClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onOrderCardClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onOrderReplacementUsingSameDesignClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onOrderReplacementUsingSameDesignClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPhoneNumberChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onPhoneNumberChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onResendDocumentBasedIdvLinkClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onResendDocumentBasedIdvLinkClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSaveShippingAddressClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSaveShippingAddressClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelectCancellationReason", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectCancellationReason"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onShippingAddressUpdate", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onShippingAddressUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSignatureTextChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSignatureTextChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSignatureFontChange", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSignatureFontChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSkipFeedbackClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSkipFeedbackClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSendFeedbackClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onSendFeedbackClick"), _class.prototype)), _class));
export { ConnectedPage as default };